"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  days: {
    display: 'flex',
    flexWrap: 'wrap',
    width: 304,
    marginBottom: 12,
    marginTop: 4
  },
  dayContainer: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 44,
    height: 40,
    marginTop: 2,
    marginBottom: 2,
    '&:nth-child(7n+1)': {
      width: 42,
      paddingRight: 4
    },
    '&:nth-child(7n)': {
      width: 42,
      paddingLeft: 4
    },
    '&.inRange': {
      backgroundColor: `${theme.calendar.dayInRange} !important`,
      color: `${theme.calendar.textColor} !important`
    },
    '&.startRange': {
      borderRight: `4px solid ${theme.calendar.dayInRange}`,
      borderLeft: `4px solid ${theme.calendar.mainBgColor}`,
      '&:nth-child(7n+1)': {
        border: 'none',
        backgroundColor: `${theme.calendar.dayInRange} !important`
      },
      '&:nth-child(7n)': {
        border: 'none'
      }
    },
    '&.endRange': {
      borderLeft: `4px solid ${theme.calendar.dayInRange}`,
      borderRight: `4px solid ${theme.calendar.mainBgColor}`,
      '&:nth-child(7n+1)': {
        border: 'none'
      },
      '&:nth-child(7n)': {
        border: 'none',
        backgroundColor: `${theme.calendar.dayInRange} !important`
      }
    }
  },
  day: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    borderRadius: theme.calendar.borderRadius,
    color: theme.calendar.textColor,
    fontSize: 14,
    width: 40,
    height: 40,
    lineHeight: '19px',
    '&:nth-child(7n+1)': {
      marginLeft: 0
    },
    '&:nth-child(7n)': {
      marginRight: 0
    },
    '&:hover': {
      cursor: 'pointer',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: theme.calendar.dayHoverColor,
      backgroundColor: theme.calendar.dayHoverBgColor,
      color: theme.calendar.dayHoverColor
    },
    '&.active': {
      color: theme.calendar.dayActiveColor,
      '&:hover': {
        color: theme.calendar.dayHoverColor
      }
    },
    '&.disabled': {
      color: `${theme.calendar.dayDisabledColor} !important`,
      '&:hover': {
        cursor: 'default',
        borderColor: 'transparent',
        backgroundColor: 'transparent'
      }
    },
    '&.otherMonth': {
      color: theme.calendar.dayOtherMonthColor,
      '&:hover': {
        color: theme.calendar.dayHoverColor
      },
      '&.inRange': {
        backgroundColor: `${theme.calendar.dayInRange} !important`,
        color: `${theme.calendar.textColor} !important`,
        '&:hover': {
          color: `${theme.calendar.dayHoverColor} !important`
        }
      }
    },
    '&.selected': {
      color: `${theme.calendar.daySelectedColor} !important`,
      borderColor: theme.calendar.daySelectedBorderColor,
      backgroundColor: theme.calendar.daySelectedBgColor,
      '&.active:hover': {
        color: theme.calendar.daySelectedColor
      }
    },
    '&.selectedDisabled': {
      color: `${theme.calendar.dayDisabledColor} !important`,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: theme.calendar.error,
      backgroundColor: 'transparent',
      '&:hover': {
        cursor: 'default',
        borderColor: `${theme.calendar.error} !important`
      }
    },
    '&.dayToday': {
      color: theme.calendar.error,
      backgroundColor: theme.calendar.dayTodayBgColor,
      border: 'none',
      borderRadius: '50%'
    }
  },
  small: {
    width: 216,
    '& $days': {
      marginBottom: 12
    },
    '& $dayContainer': {
      width: 32,
      height: 24,
      marginTop: 4,
      marginBottom: 4,
      '&:nth-child(7n+1)': {
        width: 28,
        paddingRight: 4
      },
      '&:nth-child(7n)': {
        width: 28,
        paddingLeft: 4
      },
      '&.inRange': {
        backgroundColor: `${theme.calendar.dayInRange} !important`,
        color: `${theme.calendar.textColor} !important`
      }
    },
    '& $day': {
      display: 'flex',
      width: 24,
      height: 24,
      fontSize: 12,
      lineHeight: '17px'
    }
  }
});

exports.default = _default;